import { render } from "./flight-add.vue?vue&type=template&id=4232c824"
import script from "./flight-add.vue?vue&type=script&lang=js"
export * from "./flight-add.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__